import axios from 'axios';
import store from '../store';
import Cookies from 'js-cookie';
import { ca } from 'date-fns/locale';
// form data
let api_url = store.getState().ui.api_url;
/**********************************************/
/* Name: get faculties */
/**********************************************/
export const getFacultiesService = async () => {
  const token = Cookies.get('token');
  try {
    const response = await axios.get(`${api_url}/api/v1/colleges`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return {
      status: 'success',
      data: response.data.data,
    };
  } catch (error) {
    if (error.code === 'ERR_NETWORK') {
      return {
        status: 'error',
        statusCode: error.code,
        message: 'خطأ في الاتصال بالخادم',
      };
    } else {
      return {
        status: 'error',
        message: error.response.data.message,
      };
    }
  }
};
/**********************************************/
/* Name:  getFacultyInfoService */
/**********************************************/
export const getFacultyInfoService = async (faculty) => {
  const token = Cookies.get('token');
  const data = {
    collegeName: faculty,
  };
  try {
    const response = await axios.post(`${api_url}/api/v1/colleges`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return {
      status: 'success',
      data: response.data.data,
    };
  } catch (error) {
    if (error.code === 'ERR_NETWORK') {
      return {
        status: 'error',
        statusCode: error.code,
        message: 'خطأ في الاتصال بالخادم',
      };
    } else {
      return {
        status: 'error',
        message: error.response.data.message,
      };
    }
  }
};
/**********************************************/
/* Name:  get nationalities */
/**********************************************/
export const getNationalitiesService = async () => {
  const token = Cookies.get('token');
  try {
    const response = await axios.get(
      `${api_url}/api/v1/studentID/getNationalities`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return {
      status: 'success',
      data: response.data.data,
    };
  } catch (error) {
    if (error.code === 'ERR_NETWORK') {
      return {
        status: 'error',
        statusCode: error.code,
        message: 'خطأ في الاتصال بالخادم',
      };
    } else {
      return {
        status: 'error',
        message: error.response.data.message,
      };
    }
  }
};

/**********************************************/
/* Name: getTourismProgramsService Request */
/* Description: getTourismPrograms Request */
/**********************************************/
export const getTourismProgramsService = async (college) => {
  try {
    const response = await axios.get(
      `${api_url}/api/v1/colleges/tourism/${college}/programs`
    );
    return { status: 'success', data: response.data.data };
  } catch (error) {
    if (error.code === 'ERR_NETWORK') {
      return {
        status: 'error',
        statusCode: error.code,
        message: 'خطأ في الاتصال بالخادم',
      };
    } else {
      return {
        status: 'error',
        message: error.response.data.message,
      };
    }
  }
};
/**********************************************/
